<template>
  <section class="content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>个人信息</span>
      </div>
      <div class="content">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="联系方式">
            <el-input v-model="form.name" style="width:200px;" placeholder="姓名"></el-input>
            <el-input
              v-model="account.mobile"
              style="width:200px;margin-left:20px;"
              maxlength="11"
              placeholder="手机号"
              :disabled="true"
              v-if="account.userid"
            ></el-input>
            <el-input
              v-model="form.phone"
              style="width:200px;margin-left:20px;"
              maxlength="11"
              placeholder="手机号"
              v-else
            ></el-input>
            <el-button type="text" @click="logout" style="margin-left:10px;color:#229ef6" v-if="account.userid">换个手机号</el-button>
          </el-form-item>
          <el-form-item label="验证码" v-if="!account.userid">
            <el-input v-model="form.code" style="width:100px;" maxlength="4" placeholder="验证码"></el-input>
            <el-button
              type="danger"
              style="margin-left:20px"
              @click="getCode"
              :disabled="disabled?true:false"
            >
              <span>
                <span v-if="count">{{count}} 秒</span>
                <span v-else>发送验证码</span>
              </span>
            </el-button>
          </el-form-item>
          <el-form-item label="取件地址">
            <el-cascader
              :options="region"
              :props="props"
              v-model="form.city"
              @change="handleChange"
            ></el-cascader>
            <el-input
              v-model="form.address"
              style="width:240px;margin-left:20px;"
              placeholder="详细地址"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </section>
</template>

<script>
import region from "@/utils/region";
import{encrypt,setCookie} from "@/utils"

export default {
  props:["account"],
  data() {
    return {
      input1: "",
      input2: "",
      form: {
        name: "",
        city: ["", "", ""],
        phone: "",
        address: "",
        code: ""
      },
      smscode: "8686",
      region: [],
      area: [],
      props: {
        value: "name",
        label: "name",
        children: "children"
      },
      count: "",
      disabled: true
    };
  },
  methods: {
    handleChange(value) {
      console.log(value);
      // this.form.city = value;
    },
    getCode() {
      window._hmt.push([
        "_trackEvent",
        "发送验证码",
        "点击",
        "手机号",
        this.phone
      ]);
      const TIME_COUNT = 59;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.disabled = true;
        this.sendSms();
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.disabled = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    sendSms() {
      let smscode = Math.round(9000 * Math.random() + 1000).toString();
      this.smscode = smscode;
      let params = {
        smscode: smscode,
        phone: this.form.phone
      };
      this.$store.dispatch("account/fetchSmsData", { params }).then(() => {
        if (this.$store.state.account.sms.code !== 200) {
          Toast("验证码发送失败,请稍后再试.");
        } else {
          Toast("验证码发送成功.");
        }
      });
    },
    logout(){
      setCookie("account","",true);
      this.code = '';
      this.$store.commit('account/setAccountData', {data:{}});
    },
    onLogin() {
      let parent_id = 0;
      if (localStorage.code) {
        parent_id = localStorage.code;
      }
      let params = {
        phone: this.form.phone,
        parentId: parent_id
      };
      this.$store.dispatch("account/fetchLoginData", { params }).then(() => {
        if (this.$store.state.account.user.userid) {
          let account = JSON.stringify(this.$store.state.account.user);
          setCookie("account", encrypt(account), true);
          this.$message({
            message: "用户登录成功.",
            type: "success"
          });
        } else {
          this.$message({
            message: "用户登录失败.",
            type: "error"
          });
        }
      });
    }
  },
  mounted() {
    this.region = region;
  },
  watch: {
    form: {
      handler(value) {
        this.$emit("changeContent", value);
      },
      deep: true
    },
    "form.phone": function(value) {
      let re = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (re.test(value) && value.length == 11 && this.timer == null) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    "form.code": function(value) {
      if (value == this.smscode) {
        this.verify = true;
        this.onLogin();
      } else {
        if (value.length == 4) {
          this.$message({
            message: "验证码不正确.",
            type: "error"
          });
        }
      }
    }
  }
};
</script>

<style scoped>
.content {
  margin-top: 10px;
}
.title {
  border-bottom: solid #efefef 1px;
  padding: 10px 0;
  font-size: 20px;
  color: #f9415d;
}
.title::before {
  content: "";
  display: inline-block;
  width: 12px;
  height: 12px;
  border: solid #f9415d 2px;
  margin-right: 10px;
  rotate: 10px;
  transform: rotate(45deg);
}
.title span {
  color: #ccc;
}
.detailsPic {
  background: url(../../../assets/image/detailsPic.png) center center no-repeat;
  background-size: 1254px 447px;
  width: 1254px;
  height: 447px;
  margin-top: 20px;
}
</style>
